import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getItemRequestTrackingDetailsApi } from './getItemRequestTrackingDetails.api'
import getItemRequestTrackingDetailsInitialState from './getItemRequestTrackingDetails.initialState'
import {
  GetItemRequestTrackingDetailsErrorResponse,
  GetItemRequestTrackingDetailsRequestPayload
} from './getItemRequestTrackingDetails.types'

export const getItemRequestTrackingDetails = createAsyncThunk(
  urls.offers.getItemRequestTrackingDetails,
  async (payload: GetItemRequestTrackingDetailsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getItemRequestTrackingDetailsApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getItemRequestTrackingDetailsSlice = createSlice({
  name: urls.offers.getItemRequestTrackingDetails,
  initialState: getItemRequestTrackingDetailsInitialState,
  reducers: {
    clearItemRequestTrackingDetailsSuccess: (state) => {
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getItemRequestTrackingDetails.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getItemRequestTrackingDetails.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getItemRequestTrackingDetails.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetItemRequestTrackingDetailsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getItemRequestTrackingDetailsActions, reducer: getItemRequestTrackingDetailsReducer } =
  getItemRequestTrackingDetailsSlice

export const { clearItemRequestTrackingDetailsSuccess } = getItemRequestTrackingDetailsActions
export default getItemRequestTrackingDetailsSlice.reducer
